export default "__VITE_ASSET__Bj8kE1ci__"